(function () {
  var doubleClickTimeout = 500;

  // Helper function to bind touch or click based on the device
  this.BindClick = function (node, callback) {
    /*
    if ('ontouchstart' in document) {
      var event = null;
      node._fyaClickListeners = {
        click: function (e) {
          if (event === null) {
            callback(e, node);
          } else {
            event = null;
          }
        },
        touchstart: function (e) {
          event = e;
        },
        touchend: function (e) {
          if (event) {
            callback(event, node);
          }
        },
        touchmove: function (e) {
          event = null;
        },
      };

      node.addEventListener('touchstart', node._fyaClickListeners.touchstart, { passive: false });
      node.addEventListener('touchend', node._fyaClickListeners.touchend, { passive: false });
      node.addEventListener('touchmove', node._fyaClickListeners.touchmove, { passive: false });
      */
    node._fyaClickListeners = {
      click: function (e) {
        callback(e, node);
      },
    };

    node.addEventListener('click', node._fyaClickListeners.click);
  };

  // Helper function to bind double touch or click based on the device
  this.BindDoubleClick = function (node, callback) {
    node._fyaClickTimeout = null;

    if ('ontouchstart' in document) {
      var event = null;
      node._fyaClickListeners = {
        click: function (e) {
          if (event === null) {
            if (node._fyaClickTimeout) {
              callback(e, node);
              clearTimeout(node._fyaClickTimeout);
              node._fyaClickTimeout = null;
            } else {
              node._fyaClickTimeout = setTimeout(
                function () {
                  clearTimeout(node._fyaClickTimeout);
                  node._fyaClickTimeout = null;
                }.bind(this),
                doubleClickTimeout
              );
            }
          } else {
            event = null;
          }
        },
        touchstart: function (e) {
          event = e;
        },
        touchend: function (e) {
          if (event) {
            if (node._fyaClickTimeout) {
              callback(e, node);
              clearTimeout(node._fyaClickTimeout);
              node._fyaClickTimeout = null;
            } else {
              node._fyaClickTimeout = setTimeout(
                function () {
                  clearTimeout(node._fyaClickTimeout);
                  node._fyaClickTimeout = null;
                }.bind(this),
                doubleClickTimeout
              );
            }
          }
        },
        touchmove: function (e) {
          event = null;
        },
      };

      node.addEventListener('touchstart', node._fyaClickListeners.touchstart);
      node.addEventListener('touchend', node._fyaClickListeners.touchend);
      node.addEventListener('touchmove', node._fyaClickListeners.touchmove);
    } else {
      node._fyaClickListeners = {
        click: function (e) {
          if (node._fyaClickTimeout) {
            callback(e, node);
            clearTimeout(node._fyaClickTimeout);
            node._fyaClickTimeout = null;
          } else {
            node._fyaClickTimeout = setTimeout(
              function () {
                clearTimeout(node._fyaClickTimeout);
                node._fyaClickTimeout = null;
              }.bind(this),
              doubleClickTimeout
            );
          }
        },
      };
    }

    node.addEventListener('click', node._fyaClickListeners.click);
  };

  this.UnbindClick = function (node) {
    if (!node._fyaClickListeners) {
      return;
    }

    node.removeEventListener('click', node._fyaClickListeners.click);
    if ('ontouchstart' in document) {
      node.removeEventListener(
        'touchstart',
        node._fyaClickListeners.touchstart
      );
      node.removeEventListener('touchend', node._fyaClickListeners.touchend);
      node.removeEventListener('touchmove', node._fyaClickListeners.touchmove);
    }
  };
}).bind(window.FindYourAdventure)();
